import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Card, CardBody, CardTitle, CardText, Button, Row, Col } from "reactstrap";
import Barcode from "react-barcode";
import productService from "../../redux/services/product.service";

const ProductVariant = () => {
    const { id } = useParams();
    const [variant, setVariant] = useState(null);
    const barcodeRef = useRef(); // For printing barcode
    const pdfRef = useRef(); // For downloading barcode as PDF

    useEffect(() => {
        productService.getVariant(id)
            .then(response => {
                setVariant(response.data.productInfo);
            })
            .catch(error => {
                console.error("Error fetching variant:", error);
            });
    }, [id]);

    const handlePrintBarcode = () => {
        if (barcodeRef.current) {
            const printContent = barcodeRef.current.innerHTML;
            const originalContent = document.body.innerHTML;

            document.body.innerHTML = printContent;
            window.print();
            document.body.innerHTML = originalContent;
            window.location.reload(); // Restore page content
        }
    };

    return (
        <div className="container mt-4">
            <h3 className="mb-4 text-center">📦 Product Variant Details</h3>

            {variant ? (
                <Card className="shadow border-0">
                    <CardBody>
                        <Row>
                            {/* Product Image */}
                            <Col md="4" className="text-center">
                                {variant.images?.length > 0 && (
                                    <img
                                        src={variant.images[0]}
                                        alt="Product Variant"
                                        className="img-fluid rounded shadow"
                                        style={{ maxWidth: "100%", height: "auto" }}
                                    />
                                )}
                            </Col>

                            {/* Variant Details */}
                            <Col md="8">
                                <CardTitle tag="h4" className="mb-3">{variant.label}</CardTitle>

                                <Row>
                                    <Col md="6">
                                        <CardText><strong>Name:</strong> {variant.name}</CardText>
                                        <CardText><strong>Buy Price:</strong> ₹{variant.buyPrice}</CardText>
                                        <CardText><strong>Selling Price:</strong> ₹{variant.sellingPrice}</CardText>
                                        <CardText><strong>MRP:</strong> ₹{variant.mrp}</CardText>
                                    </Col>
                                    <Col md="6">
                                        <CardText><strong>Stock:</strong> {variant.stock}</CardText>
                                        <CardText><strong>Cashback:</strong> {variant.cashBack}%</CardText>
                                        <CardText><strong>Status:</strong> {variant.status === 1 ? "✅ Active" : "❌ Inactive"}</CardText>
                                    </Col>
                                </Row>

                                {/* Description */}
                                <CardText className="mt-3">
                                    <strong>Description:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: variant.description }} />
                                </CardText>
                            </Col>
                        </Row>

                        {/* Barcode Section */}
                        <div className="text-center mt-4 p-3 bg-light border rounded">
                            <div ref={barcodeRef}>
                                <Barcode value={variant.barcode} width={1.5} height={50} />
                                <p className="mt-2 font-weight-bold">{variant.barcode}</p>
                            </div>
                        </div>

                        {/* Buttons */}
                        <div className="text-center mt-4">
                            <Button color="success" className="mx-2" onClick={handlePrintBarcode}>
                                📥 Download Barcode PDF
                            </Button>
                        </div>
                    </CardBody>
                </Card>
            ) : (
                <p className="text-center">Loading product variant...</p>
            )}

            {/* Hidden Section for PDF Download */}
            {variant && (
                <div ref={pdfRef} className="d-none">
                    <h4 className="text-center">{variant.label}</h4>
                    <Barcode value={variant.barcode} width={1.5} height={50} />
                </div>
            )}
        </div>
    );
};

export default ProductVariant;
